import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=04ff0e8a&"
import script from "./ModalPanel.vue?vue&type=script&lang=js&"
export * from "./ModalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports